import {
  Button,
  Space,
  Table,
  Modal,
  Form,
  InputNumber,
  Input,
  Select,
  Pagination,
} from 'antd';
import { useContext } from 'react';
import CreateDrawer from '../../../components/create';
import { PageContext } from '../../../lib/context';
import CustomerForm from './form';
import ViewCustomerInfo from './view-customer-info';
import CustomerReceit from './customer-receit';
import Loading from '../../../components/loader';

const SubscribersView = () => {
  const {
    subscribers,
    usersColumns,
    _submitHandler,
    filterBarangays,
    showForm,
    showReceit,
    handleCancel,
    _onFinishPay,
    payments_form,
    searchForm,
    municipalities,
    _onFinishSearch,
    _searchFormChangeHandler,
    tableChange,
    subscriber_loading,
    loading,
    limit,
    offset,
    handlePaginationChange,
    total,
    current,
    handleSort,
  } = useContext(PageContext);
  // const [showReceit, setShowReceit] = useState<boolean>(false)
  return (
    <div className="flex flex-col px-10">
      <div className="items-start align-start">
        <p className="text-3xl font-bold">Subscribers</p>
      </div>
      <Space>
        <CreateDrawer
          title={showForm ? 'Create Subscriber' : 'Customer Information'}
          buttonTitle="Create Subscriber"
          _submitHandler={_submitHandler}
          addForm={true}
          width={'100%'}
        >
          {showForm ? <CustomerForm /> : <ViewCustomerInfo />}
        </CreateDrawer>
      </Space>
      <p className="text-xl font-bold mt-5">Recent Subscribers</p>
      <div className="flex flex-row mb-5">
        <Form layout="inline" form={searchForm} onFinish={_onFinishSearch}>
          <Form.Item name="name">
            <Input
              style={{ width: 250 }}
              placeholder="Search by ID or Lastname"
              allowClear
              size="large"
            />
          </Form.Item>
          <Form.Item name="municipality">
            <Select
              allowClear
              style={{ width: 250 }}
              size="large"
              placeholder="Filter by Municipality"
              options={municipalities}
              showSearch
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={() => _searchFormChangeHandler()}
            />
          </Form.Item>
          <Form.Item name="barangay">
            <Select
              allowClear
              style={{ width: 250 }}
              size="large"
              placeholder="Filter by Barangay"
              options={filterBarangays}
              showSearch
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            />
          </Form.Item>
          <Form.Item name="meter">
            <Input
              style={{ width: 250 }}
              size="large"
              placeholder="Search Meter ID"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" size="large" htmlType="submit">
              SEARCH
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="flex flex-row">
        <div className="w-full mr-3">
          {loading || subscriber_loading ? (
            <div className="mt-32">
              <Loading show={loading || subscriber_loading} />
            </div>
          ) : (
            <>
              <Table
                dataSource={subscribers}
                columns={usersColumns}
                pagination={false}
                onChange={handleSort}
              />
              <div className="py-10 text-right">
                <Pagination
                  onChange={handlePaginationChange}
                  total={total}
                  pageSize={limit}
                  current={current}
                />
              </div>
            </>
          )}
        </div>
        <div>
          <Modal
            title="Customer Receit"
            visible={showReceit}
            onCancel={handleCancel}
            onOk={handleCancel}
            width={1150}
            footer={
              <div style={{ textAlign: 'left' }}>
                <Form
                  form={payments_form}
                  onFinish={_onFinishPay}
                  layout="vertical"
                >
                  {/* {displayAmount && <> */}
                  <Form.Item
                    name="amount"
                    rules={[{ required: true, message: 'Amount is required' }]}
                    label="Enter Amount"
                  >
                    <div className="">
                      <InputNumber
                        placeholder="Enter Amount"
                        style={{ width: 350 }}
                      />
                    </div>
                  </Form.Item>
                  <Form.Item hidden={true} name="id">
                    <InputNumber />
                  </Form.Item>
                  <Form.Item hidden={true} name="billing_id">
                    <InputNumber />
                  </Form.Item>
                  <Form.Item hidden={true} name="subscriber_id">
                    <InputNumber />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            }
          >
            <CustomerReceit />
          </Modal>
          {/* <Modal
            title="Bill Information"
            centered
            visible={visible}
            onCancel={() => setVisible(false)}
            width={1000}
            footer={
              <div style={{ textAlign: 'left' }}>
                <Form form={form} onFinish={_onFinish} layout="vertical">
                  {displayAmount && (
                    <>
                      <Form.Item
                        name="amount"
                        rules={[
                          { required: true, message: 'Amount is required' },
                        ]}
                        label="Enter Amount"
                      >
                        <div className="mb-2">
                          <InputNumber
                            placeholder="Enter Amount"
                            style={{ width: 350 }}
                          />
                        </div>
                      </Form.Item>
                      <Form.Item hidden={true} name="billing_id">
                        <InputNumber />
                      </Form.Item>
                      <Form.Item hidden={true} name="subscriber_id">
                        <InputNumber />
                      </Form.Item>
                      <Form.Item>
                        <Button type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form>
              </div>
            }
          >
            <BillsInformation />
          </Modal> */}
        </div>
      </div>
    </div>
  );
};

export default SubscribersView;
